import React, { useState, useEffect } from 'react';
import { fetchSounds } from '../services/strapi';
import AudioPlayer from './AudioPlayer';

const Audio = () => {
  const [audios, setAudio] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


  useEffect(() => {
    const getAudio = async () => {
      try {
        setLoading(true);
        const data = await fetchSounds();
        console.log(data);
        setAudio(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    getAudio();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  console.log(audios)


//   const playlist = [
//     {
//       title: "Song 1",
//       artist: "Artist 1",
//       url: `${baseUrl}/uploads/Love_of_my_life_shorter_bce0dbb299.mp3`,
//       artwork: "/path/to/artwork1.jpg" // optional
//     },
//     {
//       title: "Song 2",
//       artist: "Artist 2",
//       url: `${baseUrl}/uploads/Love_of_my_life_shorter_bce0dbb299.mp3`,
//       artwork: "/path/to/artwork2.jpg"
//     },
//     // Add more tracks as needed
//   ];
  

    return (
        <>
           <section>
           <AudioPlayer playlist={audios} />
         </section>
        </>
          );
    };
    
    export default Audio;